'use client';

import { createContext, type ReactNode } from 'react';

import { DEFAULT_FEATURE_FLAGS } from '../lib/defaults';
import type { FeatureFlagsConfig } from '../types';

/**
 * Context for feature flags - provides flags to client components
 */
export const FeatureFlagsContext = createContext<FeatureFlagsConfig | null>(
  null,
);

interface FeatureFlagsProviderProps {
  children: ReactNode;
  flags?: FeatureFlagsConfig;
}

/**
 * Provider for feature flags - pass flags from server component
 *
 * Usage:
 * ```tsx
 * // In a Server Component
 * const flags = await getFeatureFlagsConfigAction();
 *
 * return (
 *   <FeatureFlagsProvider flags={flags}>
 *     {children}
 *   </FeatureFlagsProvider>
 * );
 * ```
 */
export function FeatureFlagsProvider({
  children,
  flags = DEFAULT_FEATURE_FLAGS,
}: FeatureFlagsProviderProps) {
  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}
